import { CommonModule, IMAGE_CONFIG } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { SharedPipesModule } from '@app/@core/pipes/shared-pipes.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxCaptchaModule } from 'ngx-captcha';
import { SharedDirectivesModule } from '@app/@core/directives/shared-directives.module';
@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    CardModule,
    PasswordModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimengModule,
    ToastModule,
    SharedPipesModule,
    NgOtpInputModule,
    NgxCaptchaModule,
    SharedDirectivesModule
  ],
  providers: [
  {
    provide: IMAGE_CONFIG,
    useValue: {
      disableImageSizeWarning: true
    }
  }
]
})
export class LoginModule {}
